exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/requisition-products/requisition-products.component.scss
// module id = ../../../../../src/app/shared/components/requisition-products/requisition-products.component.scss
// module chunks = main